// Riktning på en CRM-aktivitet: vem kontaktade vem.
// 'out' = TIKAB hörde av sig, 'in' = kunden hörde av sig.
// Noteringar är interna anteckningar och har ingen riktning.
import React from 'react';
import { Box, Chip, Typography } from '@mui/material';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';

export const DIRECTIONAL_TYPES = ['email', 'phone', 'meeting', 'quote'];

export const TIKAB_PARTY = { label: 'TIKAB', color: '#FF6B00', bg: '#FFF3E0', border: '#FFD0B0' };
const CUSTOMER_PARTY_COLORS = { color: '#1565C0', bg: '#E3F2FD', border: '#BBDEFB' };

/** Parterna i läsordning: avsändare först, mottagare sist. */
export function directionParties(direction, counterpartLabel) {
  const customer = { label: counterpartLabel || 'Kunden', ...CUSTOMER_PARTY_COLORS };
  return direction === 'in' ? [customer, TIKAB_PARTY] : [TIKAB_PARTY, customer];
}

/** Ett chip för en part i en kontakt — TIKAB eller motparten hos kunden. */
export function PartyChip({ party, dense }) {
  return (
    <Chip label={party.label} size="small"
      sx={{
        maxWidth: dense ? 140 : 220,
        height: dense ? 18 : 26,
        fontSize: dense ? '0.6rem' : '0.75rem',
        fontWeight: 600,
        bgcolor: party.bg, color: party.color,
        border: `1px solid ${party.border}`,
      }} />
  );
}

/** Avsändare → mottagare, i läsordning. */
export function DirectionTrail({ direction, counterpartLabel, dense }) {
  const [from, to] = directionParties(direction, counterpartLabel);
  return (
    <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: dense ? 0.25 : 0.75 }}>
      <PartyChip party={from} dense={dense} />
      <ArrowRightAltIcon sx={{ fontSize: dense ? 15 : 22, color: dense ? 'text.disabled' : '#FF6B00' }} />
      <PartyChip party={to} dense={dense} />
    </Box>
  );
}

/**
 * Klickbar riktningsväljare. Hela raden är knappen — ett klick vänder pilen,
 * så att man ser vem som hörde av sig till vem.
 */
export function DirectionToggle({ direction, counterpartLabel, onChange, label = 'Vem kontaktade vem', dense }) {
  const dir = direction === 'in' ? 'in' : 'out';
  const flip = () => onChange(dir === 'in' ? 'out' : 'in');
  return (
    <Box>
      {label && (
        <Typography variant="caption" fontWeight="bold" color="text.secondary"
          sx={{ display: 'block', mb: 0.75, textTransform: 'uppercase', letterSpacing: 0.5 }}>
          {label}
        </Typography>
      )}
      <Box role="button" tabIndex={0} onClick={flip}
        onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); flip(); } }}
        sx={{
          display: 'inline-flex', alignItems: 'center', gap: dense ? 0.75 : 1.25,
          py: dense ? 0.5 : 1, px: dense ? 0.75 : 1.5, borderRadius: '10px', cursor: 'pointer',
          border: '1px solid', borderColor: 'divider', bgcolor: '#fafafa',
          '&:hover': { borderColor: '#FF6B00', bgcolor: '#FFF8F3' },
        }}>
        <DirectionTrail direction={dir} counterpartLabel={counterpartLabel} dense={dense} />
        <Typography variant="caption" color="text.secondary">
          {dir === 'in' ? 'Kunden hörde av sig' : 'Vi hörde av oss'}{dense ? '' : ' — klicka för att byta'}
        </Typography>
      </Box>
    </Box>
  );
}
